// extracted by mini-css-extract-plugin
export default {"form_container":"CreatePartnerTeamMemberForm_form_container__lov+x","error_box":"CreatePartnerTeamMemberForm_error_box__hSMRG"};